import {Injectable, Injector} from "@angular/core";
import {CustomObjectSearchModel} from "./custom-object-search.model";
import {
    CustomObjectAssociationContext,
    CustomObjectTypeSearchModel
} from "../custom-object-type/custom-object-type-search.model";

@Injectable()
export class MembershipTypeCustomObjectSearchModel extends CustomObjectSearchModel {
    constructor(injector: Injector) {
        super(injector);
        this.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.MEMBERSHIP_TYPE;
    }

    override getResource(): string {
        return "custom-membership-group";
    }
}
